import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@store';
import {
  useScroll,
  SecurityLogs,
  PermissionEnum,
  PermissionDenied,
} from '@ui/src';
import { setLogsTakeCount } from '../store/slices/security';
import { useLazyGetCustomerLocksAuditLogsQuery } from '../store/services/individual';
import {
  schema,
  columns,
  columnsLabels,
  filtersSchema,
} from './variables/logs';

import cn from '../information.module.css';

const IndividualCustomerSecurityLogs = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const {
    individualCustomers: {
      info: {
        general: { baseInformation },
        security: { logs, logsPagination, logsTakeCount },
      },
    },
    root: { activePermissions },
  } = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  const [getList, { isFetching, isLoading }] =
    useLazyGetCustomerLocksAuditLogsQuery();

  useScroll({
    element: scrollRef,
    requestInProgress: isFetching,
  });

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      const { offsetHeight } = scrollRef.current;

      if (offsetHeight) {
        const take = offsetHeight / 58;

        dispatch(setLogsTakeCount(Math.ceil(take + 3)));
      }
    }
  }, [scrollRef]);

  let content;

  if (!activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <>
        <SecurityLogs
          logs={logs}
          pagination={logsPagination}
          takeCount={logsTakeCount}
          activePermissions={activePermissions}
          schema={schema}
          getList={getList}
          isLoading={isLoading}
          filtersSchema={filtersSchema}
          columns={columns}
          columnsLabels={columnsLabels}
          isFetching={isFetching}
          tableTopClassName={cn.securityTableTop}
          userId={baseInformation?.userId}
        />
        <Outlet />
      </>
    );
  }

  return (
    <div className={cn.securityLocksContent} ref={scrollRef}>
      {content}
    </div>
  );
};

export default IndividualCustomerSecurityLogs;
